import cs from 'classnames';
import React, { useEffect, useState } from 'react';
import { usePreviewTemplate } from '../../contexts/PreviewTemplateContext';
import { Template } from '../../domain/entities/template';
import { PreviewHeader } from './PreviewHeader/PreviewHeader';
import { TemplateSaved } from './TemplateSaved/TemplateSaved';
import { TemplateDemoPreview } from './TemplateDemoPreview/TemplateDemoPreview';
import { templatePreviewModalDataHooks } from './TemplatePreviewModal.dataHooks';
import s from './TemplatePreviewModal.scss';

type Props = {
  template: Template;
  isSaved: boolean;
  setIsSaved: (v: boolean) => void;
};

export const TemplatePreviewModal: React.FC<Props> = ({
  template,
  isSaved,
  setIsSaved,
}) => {
  const [, setPreviewTemplate] = usePreviewTemplate();
  const [isAppear, setIsAppear] = useState(false);

  useEffect(() => {
    setIsAppear(true);
    document.querySelector('body')!.className = s.rmScroll;

    return () => {
      document.querySelector('body')!.className = '';
    };
  }, []);

  const onButtonClick = () => {
    setIsSaved(true);
  };

  const onBrowseMoreTemplatesButtonClick = () => {
    setPreviewTemplate(null);
    setIsSaved(false);
  };

  return (
    <div
      data-hook={templatePreviewModalDataHooks.container()}
      className={cs(s.templatePreviewModal, {
        [s.appear]: isAppear,
      })}
    >
      {isSaved ? (
        <TemplateSaved
          onCloseClick={() => setIsSaved(false)}
          onButtonClick={onBrowseMoreTemplatesButtonClick}
          savedTemplate={template}
        />
      ) : (
        <div className={s.previewBox}>
          <PreviewHeader onButtonClick={onButtonClick} />
          <TemplateDemoPreview template={template} />
        </div>
      )}
    </div>
  );
};
